// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App_tooltip__LQX4F {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--color-bg-panel);
    /* Black background with slight transparency */
    color: var(--color-text);
    /* White text color */
    border: 1px solid var(--color-border);
    /* Subtle white border */
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);
    /* Slightly darker shadow for better contrast */
    z-index: 1000;
    max-width: 300px;
    text-align: center;
    font-family: Arial, sans-serif;
    /* Optional: Set a clean font for better readability */
    font-size: var(--font-size-body);
    /* Adjust text size for readability */
    line-height: 1.5;
    /* Improve line spacing */
}

.App_app__zr1wm {
    display: flex;
}


.App_sideHeader__PyG1O {
    position: fixed;
    top: 70px;
    left: -360px;
    height: calc(100vh - 70px);
    width: 340px;
    background-color: var(--color-bg-side);
    color: var(--color-text);
    display: flex;
    flex-direction: column;
    padding: 20px;
    transition: left 0.3s ease;
    z-index: 900;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.55);
}

.App_sideNavContent__9Yf1m {
    width: 100%;
}

.App_sideHeaderOpen__F7neK {
    left: 0;
}

.App_hamburger__N9fDT {
    position: relative;
    top: auto;
    right: auto;
    background-color: var(--color-bg-panel);
    border: 1px solid var(--color-border);
    font-size: var(--font-size-section);
    cursor: pointer;
    color: var(--color-text);
    z-index: 2;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.App_mainContent__mD5IX {
    top: 100px;
    left: 0px;
    padding: 10px;
    width: 100%;
    overflow-x: hidden;
    /* overflow-y: auto; */
    /* Ensure scrolling for the main content */
    transition: margin-left 0.3s ease, width 0.3s ease;
}

/* .sideHeaderOpen~.mainContent {
    margin-left: 270px;
} */

/* Main container */
.App_container__Rt8T2 {
    /* display: flex; */
    /* Enables flex layout for sidebar and main content */
    /* flex-direction: column; */
    /* Default to vertical stacking */
    height: 100vh;
    /* Full viewport height */
    width: 100%;
    /* Full width */
    background-color: var(--color-bg);
    /* Light background for contrast */
    /* overflow-y: scroll; */
    /* Ensure scrolling even with a sidebar */
}

/* App Footer */
.App_appFooter__eNXpo {
    border-top: 1px solid var(--color-border);
    background-color: var(--color-bg-panel);
}

.App_appFooterInner__IoZ7Z {
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px 24px;
    display: flex;
    flex-wrap: nowrap;
  white-space: nowrap;
    align-items: center;
    justify-content: flex-start;
    gap: 12px 20px;
    color: var(--color-text-muted);
    font-size: var(--font-size-caption);
}

.App_appFooterBrand__tUF5E {
    display: flex;
    flex-direction: column;
    gap: 2px;
    color: var(--color-text-muted);
}

.App_appFooterTitle__6KUv4 {
    font-weight: 600;
    color: var(--color-text);
}

.App_appFooterMeta__umVa9 {
    font-size: var(--font-size-caption);
}

.App_appFooterLinks__AAyKQ {
    display: flex;
    align-items: center;
    gap: 12px;
}

.App_appFooterLink__KLybn {
    background: none;
    border: none;
    padding: 4px 6px;
    border-radius: 6px;
    color: var(--color-text-muted);
    font-size: var(--font-size-caption);
    cursor: pointer;
    transition: color 0.2s ease, background-color 0.2s ease;
}

.App_appFooterLink__KLybn:hover {
    color: var(--color-text);
    background-color: var(--color-bg-muted);
}

.App_appFooterLink__KLybn:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px var(--color-bg), 0 0 0 4px var(--color-accent);
}

.App_appFooterDisclaimer__NdIWJ {
    flex: 1 1 260px;
    text-align: right;
}

@media (max-width: 768px) {
    .App_appFooterInner__IoZ7Z {
        flex-direction: column;
        align-items: flex-start;
    }

    .App_appFooterDisclaimer__NdIWJ {
        text-align: left;
    }
}

.App_containerWithSidebar__vQZSt .App_mainContent__mD5IX {
    margin-left: 340px;
    width: calc(100% - 340px);
}

/* Header styling */
.App_header__fhC8n {
    background-color: var(--color-bg-header);
    /* Dark background for header */
    color: var(--color-text);
    /* White text */
    padding: 15px 20px;
    /* Spacing for header content */
    font-size: var(--font-size-title);
    /* Larger text for title */
    font-weight: bold;
    /* Bold title */
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    /* Subtle shadow for depth */
    text-align: center;
    /* Center-align header content */
}

/* Content area styling */
.App_content__wwONY {
    flex: 1 1;
    /* Take up remaining space */
    padding: 20px;
    /* Inner spacing for content */
    overflow-y: scroll;
    /* Allow vertical scrolling */
}

@media (max-width: 768px) {
    .App_containerWithSidebar__vQZSt {
        flex-direction: column;
        /* Stack sidebar and content vertically */
    }

    .App_header__fhC8n {
        font-size: 20px;
        /* Slightly smaller header text */
        padding: 10px;
        /* Reduce padding for smaller screens */
    }
}

.App_tabs__IkL1T {
    width: 100%;
}

.App_tab__7vr6n {
    padding: 10px;
    left: 0px;
    margin-bottom: 10px;
    background-color: var(--color-bg-tab);
    color: var(--color-text);
    border: none;
    cursor: pointer;
    border-radius: 4px;
    text-align: left;
    width: 100%;
}

.App_activeTab__DXddT {
    background-color: var(--color-bg-tab-active);
    width: 100%;
}

.App_subTabs__69JLr {
    padding-left: 12px;
    margin-top: 4px;
}

.App_subTab__aXxg\\+ {
    font-size: 0.85rem;
    background-color: var(--color-bg-subtab);
}


.App_stickyHeader__cmCRN {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    /* Ensure items are spaced out */
    background-color: var(--color-bg-header);
    /* Optional: Set a background color */
    
    /* Adjust padding as needed */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    /* Optional: Add a shadow */
    position: sticky;
    top: 0;
    z-index: 1000;
}

.App_logoContainer__CWdD- {
    display: flex;
    align-items: center;
}

.App_logo__7Edbg {
    height: 80px;
    /* Adjust logo size as needed */
    width: auto;
    padding-left: 5px;
    
}

.App_loadingContainer__HttAr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: var(--color-bg);
  color: var(--color-text);
}

.App_loadingContainer__HttAr p {
  margin-top: 1rem;
  font-size: 1.2rem;
}

.App_userSection__txw-4 {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.App_headerTitleWrap__XnFzt {
  display: flex;
  align-items: center;
  margin-left: 16px;
  white-space: nowrap;
}

@media (min-width: 1025px) {
  .App_headerMobileControls__k3s9o {
    align-items: center;
    justify-content: flex-end;
    flex-wrap: nowrap;
  }
}


.App_userMenu__OqGSf {
  position: relative;
}

.App_userMenuButton__yThPq {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--color-border);
  background: var(--color-bg-panel);
  color: var(--color-text);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.App_userMenuIcon__JieMw {
  font-size: 18px;
  color: var(--color-text);
}

.App_userAvatar__DvYkj {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.App_userAvatarFallback__nQGp8 {
  font-size: 0.8rem;
  font-weight: 600;
}

.App_userMenuDropdown__vKb\\+k {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 220px;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
  padding: 10px;
  z-index: 1000;
}

.App_userMenuMeta__JGQuB {
  padding: 4px 8px 8px;
  border-bottom: 1px solid var(--color-border);
  margin-bottom: 8px;
}

.App_userMenuName__MEiMV {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-text);
}

.App_userMenuEmail__MfYq7 {
  font-size: 0.75rem;
  color: var(--color-text-muted);
}

.App_userMenuItem__NJVkH {
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  color: var(--color-text);
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.85rem;
}

.App_userMenuItem__NJVkH:hover {
  background: var(--color-bg-muted);
}

.App_userMenuSection__-9L\\+y {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 8px;
}

.App_userMenuLabel__AzM7j {
  font-size: 0.75rem;
  color: var(--color-text-muted);
}

.App_userMenuSelect__NHYOx {
  background: var(--color-bg-alt);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 6px;
  padding: 4px 6px;
  font-size: 0.75rem;
}

.App_userInfo__UEmqj {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: var(--color-text);
  font-size: 0.9rem;
}

.App_signOutButton__k8vNI {
  background: var(--color-bg-tab);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.8rem;
}

.App_signOutButton__k8vNI:hover {
  background: var(--color-bg-tab-active);
  border-color: var(--color-border);
}

@media (max-width: 768px) {
  .App_userSection__txw-4 {
    display: none;
  }
  
  .App_userInfo__UEmqj {
    font-size: var(--font-size-label);
  }
  
  .App_signOutButton__k8vNI {
    padding: 0.4rem 0.8rem;
    font-size: var(--font-size-tiny);
  }
}

.App_themeToggle__ijVfI {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--color-text);
  font-size: var(--font-size-label);
}

.App_themeLabel__gopg2 {
  color: var(--color-text-muted);
  font-size: var(--font-size-caption);
}

.App_themeSelect__gwy9a {
  background: var(--color-bg-alt);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 6px;
  padding: 2px 6px;
  font-size: var(--font-size-label);
}

.App_settingsPage__dVWtF {
  display: flex;
  gap: 24px;
  padding: 24px 16px;
}

.App_settingsSidebar__2oz0h {
  width: 220px;
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 16px;
  height: fit-content;
}

.App_settingsTitle__GtEi1 {
  margin: 0 0 12px;
  font-size: var(--font-size-section);
  color: var(--color-text-strong);
}

.App_settingsNav__Rj9rf {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.App_settingsNavItem__VP6Mb {
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  text-align: left;
  padding: 8px 10px;
  border-radius: 8px;
  cursor: pointer;
  font-size: var(--font-size-body);
}

.App_settingsNavItem__VP6Mb:hover {
  background: var(--color-bg-muted);
  color: var(--color-text);
}

.App_settingsNavItemActive__L\\+ns4 {
  background: rgba(141, 160, 216, 0.15);
  color: var(--color-accent);
}

.App_settingsContent__LSatc {
  flex: 1 1;
  min-width: 0;
}

.App_settingsPanel__Grd0E {
  background: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  padding: 20px;
}

.App_settingsPanelTitle__BWORO {
  margin: 0 0 6px;
  font-size: var(--font-size-section);
  color: var(--color-text-strong);
}

.App_settingsPanelDescription__9jQsn {
  margin: 0 0 16px;
  font-size: var(--font-size-body);
  color: var(--color-text-muted);
}

.App_settingRow__Ac11r {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-top: 1px solid var(--color-border);
}

.App_settingLabel__8-9cR {
  font-size: var(--font-size-body);
  color: var(--color-text);
}

.App_settingHint__lex7i {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.App_settingSelect__\\+MzB5 {
  min-width: 140px;
  background: var(--color-bg-alt);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: var(--font-size-body);
}

.App_uploadPanel__IprpB {
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: var(--color-bg-muted);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  padding: 16px;
}

.App_uploadRow__MkEEd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.App_uploadFileInput__RIG0A {
  background: var(--color-bg-alt);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: var(--font-size-body);
}

.App_uploadStatus__W5Dw\\+ {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
}

.App_uploadButton__gqWai {
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 8px 14px;
  background: var(--color-bg-card);
  color: var(--color-text);
  cursor: pointer;
  font-size: var(--font-size-body);
}

.App_uploadButton__gqWai:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.App_uploadMeta__sh8kG {
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.App_uploadDivider__NyWJk {
  height: 1px;
  width: 100%;
  background: var(--color-border);
  opacity: 0.6;
}

.App_typeScaleSectionHeader__GLQ5o {
  margin-top: 16px;
  margin-bottom: 6px;
  font-size: var(--font-size-label);
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.App_typeScalePresetGrid__kYZX9 {
  display: grid;
  gap: 8px;
}

.App_typeScalePresetHeader__vdRh8 {
  display: grid;
  grid-template-columns: 120px repeat(3, minmax(0, 1fr));
  gap: 8px;
  font-size: var(--font-size-caption);
  color: var(--color-text-muted);
  padding: 6px 0;
}

.App_typeScalePresetRow__HecGW {
  display: grid;
  grid-template-columns: 120px repeat(3, minmax(0, 1fr));
  gap: 8px;
  align-items: center;
}

.App_typeScalePresetLabel__05eYK {
  font-size: var(--font-size-body);
  color: var(--color-text);
}

.App_typeScalePresetInput__cDfYO {
  background: var(--color-bg-alt);
  border: 1px solid var(--color-border);
  color: var(--color-text);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: var(--font-size-body);
  width: 100%;
}

.App_typeScalePresetActions__xp7MR {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.App_typeScaleResetButton__PlNdg {
  border: 1px solid var(--color-border);
  background: var(--color-bg-muted);
  color: var(--color-text);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: var(--font-size-body);
  cursor: pointer;
}

.App_typeScaleResetButton__PlNdg:hover {
  background: var(--color-bg-panel);
}

@media (max-width: 900px) {
  .App_settingsPage__dVWtF {
    flex-direction: column;
  }
  .App_settingsSidebar__2oz0h {
    width: 100%;
  }
}

@media (max-width: 720px) {
  .App_typeScalePresetHeader__vdRh8 {
    display: none;
  }
  .App_typeScalePresetRow__HecGW {
    grid-template-columns: 1fr;
  }
}

/* Integrated Header Navigation */
.App_headerNav__CGsod {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-right: 16px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.App_headerNavLink__AutGZ {
  padding: 8px 14px;
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font-size: var(--font-size-body);
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.App_headerNavLink__AutGZ:hover {
  color: var(--color-text);
  background-color: var(--color-bg-muted);
}

.App_headerNavLinkActive__-8dop {
  color: var(--color-accent);
  background-color: rgba(141, 160, 216, 0.15);
}

.App_headerNavMobile__gVRoC {
  display: none;
  align-items: center;
  gap: 6px;
  margin: 0 12px;
}

.App_headerMobileControls__k3s9o {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-wrap: nowrap;
}

.App_headerNavMobileButton__SwwVf {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 6px 8px;
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 52px;
}

.App_headerNavMobileButton__SwwVf:hover {
  color: var(--color-text);
  background-color: var(--color-bg-muted);
}

.App_headerNavMobileButtonActive__bAJ25 {
  color: var(--color-accent);
  background-color: rgba(141, 160, 216, 0.15);
}

.App_headerNavMobileIcon__wkHZy {
  font-size: 18px;
}

.App_headerNavMobileLabel__gRnrb {
  font-size: 0.65rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

@media (max-width: 1024px) {
  .App_headerNav__CGsod {
    display: none;
  }
  .App_headerNavMobile__gVRoC {
    display: flex;
  }
  .App_headerMobileControls__k3s9o {
    order: 2;
    width: auto;
    justify-content: flex-end;
    gap: 6px;
    margin-left: auto;
  }
  .App_stickyHeader__cmCRN {
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 4px;
    padding-top: 5px;
  }
  .App_headerTitleWrap__XnFzt {
    display: flex;
    order: 3;
    width: 100%;
    justify-content: flex-end;
    padding-right: 5px;
    margin-top: 4px;
    margin-left: 0;
    white-space: normal;
  }
  .App_logoContainer__CWdD- {
    order: 1;
  }
  .App_headerNavMobile__gVRoC {
    margin: 0;
    gap: 4px;
    align-items: flex-start;
  }

  .App_logo__7Edbg {
    height: 40px;
  }
  .App_userSection__txw-4 {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
}


/* Header Navigation Dropdown */
.App_headerNavDropdown__qS\\+Ij {
  position: relative;
  display: inline-block;
}

.App_headerNavDropdown__qS\\+Ij:hover .App_headerNavDropdownMenu__VLbQZ {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.App_headerNavDropdownMenu__VLbQZ {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 140px;
  background-color: var(--color-bg-panel);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: all 0.2s ease;
  z-index: 1000;
}

.App_headerNavDropdownItem__kMF0G {
  display: block;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}

.App_headerNavDropdownItem__kMF0G:hover {
  color: var(--color-text);
  background-color: var(--color-bg-muted);
}

.App_headerNavDropdownItemActive__xJtVT {
  color: var(--color-accent);
  background-color: rgba(141, 160, 216, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,uCAAuC;IACvC,8CAA8C;IAC9C,wBAAwB;IACxB,qBAAqB;IACrB,qCAAqC;IACrC,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,+CAA+C;IAC/C,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,sDAAsD;IACtD,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,eAAe;IACf,SAAS;IACT,YAAY;IACZ,0BAA0B;IAC1B,YAAY;IACZ,sCAAsC;IACtC,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,0BAA0B;IAC1B,YAAY;IACZ,0CAA0C;AAC9C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,uCAAuC;IACvC,qCAAqC;IACrC,mCAAmC;IACnC,eAAe;IACf,wBAAwB;IACxB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,SAAS;IACT,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,0CAA0C;IAC1C,kDAAkD;AACtD;;AAEA;;GAEG;;AAEH,mBAAmB;AACnB;IACI,mBAAmB;IACnB,qDAAqD;IACrD,4BAA4B;IAC5B,iCAAiC;IACjC,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,iCAAiC;IACjC,kCAAkC;IAClC,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA,eAAe;AACf;IACI,yCAAyC;IACzC,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,iBAAiB;EACnB,mBAAmB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,mCAAmC;IACnC,eAAe;IACf,uDAAuD;AAC3D;;AAEA;IACI,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,oEAAoE;AACxE;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,mBAAmB;AACnB;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,iCAAiC;IACjC,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;IACf,0CAA0C;IAC1C,4BAA4B;IAC5B,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA,yBAAyB;AACzB;IACI,SAAO;IACP,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI;QACI,sBAAsB;QACtB,yCAAyC;IAC7C;;IAEA;QACI,eAAe;QACf,iCAAiC;QACjC,aAAa;QACb,uCAAuC;IAC3C;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,qCAAqC;IACrC,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,4CAA4C;IAC5C,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,wCAAwC;AAC5C;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,gCAAgC;IAChC,wCAAwC;IACxC,qCAAqC;;IAErC,6BAA6B;IAC7B,wCAAwC;IACxC,2BAA2B;IAC3B,gBAAgB;IAChB,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;;AAErB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;EAClC;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iCAAiC;EACjC,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,QAAQ;EACR,mCAAmC;EACnC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,QAAQ;IACR,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,QAAQ;IACR,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,QAAQ;EACV;EAOA;IACE,SAAS;IACT,QAAQ;IACR,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;AArBF;;;AAyBA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;AAC5C","sourcesContent":[".tooltip {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background-color: var(--color-bg-panel);\n    /* Black background with slight transparency */\n    color: var(--color-text);\n    /* White text color */\n    border: 1px solid var(--color-border);\n    /* Subtle white border */\n    padding: 16px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.5);\n    /* Slightly darker shadow for better contrast */\n    z-index: 1000;\n    max-width: 300px;\n    text-align: center;\n    font-family: Arial, sans-serif;\n    /* Optional: Set a clean font for better readability */\n    font-size: var(--font-size-body);\n    /* Adjust text size for readability */\n    line-height: 1.5;\n    /* Improve line spacing */\n}\n\n.app {\n    display: flex;\n}\n\n\n.sideHeader {\n    position: fixed;\n    top: 70px;\n    left: -360px;\n    height: calc(100vh - 70px);\n    width: 340px;\n    background-color: var(--color-bg-side);\n    color: var(--color-text);\n    display: flex;\n    flex-direction: column;\n    padding: 20px;\n    transition: left 0.3s ease;\n    z-index: 900;\n    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.55);\n}\n\n.sideNavContent {\n    width: 100%;\n}\n\n.sideHeaderOpen {\n    left: 0;\n}\n\n.hamburger {\n    position: relative;\n    top: auto;\n    right: auto;\n    background-color: var(--color-bg-panel);\n    border: 1px solid var(--color-border);\n    font-size: var(--font-size-section);\n    cursor: pointer;\n    color: var(--color-text);\n    z-index: 2;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.mainContent {\n    top: 100px;\n    left: 0px;\n    padding: 10px;\n    width: 100%;\n    overflow-x: hidden;\n    /* overflow-y: auto; */\n    /* Ensure scrolling for the main content */\n    transition: margin-left 0.3s ease, width 0.3s ease;\n}\n\n/* .sideHeaderOpen~.mainContent {\n    margin-left: 270px;\n} */\n\n/* Main container */\n.container {\n    /* display: flex; */\n    /* Enables flex layout for sidebar and main content */\n    /* flex-direction: column; */\n    /* Default to vertical stacking */\n    height: 100vh;\n    /* Full viewport height */\n    width: 100%;\n    /* Full width */\n    background-color: var(--color-bg);\n    /* Light background for contrast */\n    /* overflow-y: scroll; */\n    /* Ensure scrolling even with a sidebar */\n}\n\n/* App Footer */\n.appFooter {\n    border-top: 1px solid var(--color-border);\n    background-color: var(--color-bg-panel);\n}\n\n.appFooterInner {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 16px 24px;\n    display: flex;\n    flex-wrap: nowrap;\n  white-space: nowrap;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 12px 20px;\n    color: var(--color-text-muted);\n    font-size: var(--font-size-caption);\n}\n\n.appFooterBrand {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    color: var(--color-text-muted);\n}\n\n.appFooterTitle {\n    font-weight: 600;\n    color: var(--color-text);\n}\n\n.appFooterMeta {\n    font-size: var(--font-size-caption);\n}\n\n.appFooterLinks {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.appFooterLink {\n    background: none;\n    border: none;\n    padding: 4px 6px;\n    border-radius: 6px;\n    color: var(--color-text-muted);\n    font-size: var(--font-size-caption);\n    cursor: pointer;\n    transition: color 0.2s ease, background-color 0.2s ease;\n}\n\n.appFooterLink:hover {\n    color: var(--color-text);\n    background-color: var(--color-bg-muted);\n}\n\n.appFooterLink:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px var(--color-bg), 0 0 0 4px var(--color-accent);\n}\n\n.appFooterDisclaimer {\n    flex: 1 1 260px;\n    text-align: right;\n}\n\n@media (max-width: 768px) {\n    .appFooterInner {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .appFooterDisclaimer {\n        text-align: left;\n    }\n}\n\n.containerWithSidebar .mainContent {\n    margin-left: 340px;\n    width: calc(100% - 340px);\n}\n\n/* Header styling */\n.header {\n    background-color: var(--color-bg-header);\n    /* Dark background for header */\n    color: var(--color-text);\n    /* White text */\n    padding: 15px 20px;\n    /* Spacing for header content */\n    font-size: var(--font-size-title);\n    /* Larger text for title */\n    font-weight: bold;\n    /* Bold title */\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    /* Subtle shadow for depth */\n    text-align: center;\n    /* Center-align header content */\n}\n\n/* Content area styling */\n.content {\n    flex: 1;\n    /* Take up remaining space */\n    padding: 20px;\n    /* Inner spacing for content */\n    overflow-y: scroll;\n    /* Allow vertical scrolling */\n}\n\n@media (max-width: 768px) {\n    .containerWithSidebar {\n        flex-direction: column;\n        /* Stack sidebar and content vertically */\n    }\n\n    .header {\n        font-size: 20px;\n        /* Slightly smaller header text */\n        padding: 10px;\n        /* Reduce padding for smaller screens */\n    }\n}\n\n.tabs {\n    width: 100%;\n}\n\n.tab {\n    padding: 10px;\n    left: 0px;\n    margin-bottom: 10px;\n    background-color: var(--color-bg-tab);\n    color: var(--color-text);\n    border: none;\n    cursor: pointer;\n    border-radius: 4px;\n    text-align: left;\n    width: 100%;\n}\n\n.activeTab {\n    background-color: var(--color-bg-tab-active);\n    width: 100%;\n}\n\n.subTabs {\n    padding-left: 12px;\n    margin-top: 4px;\n}\n\n.subTab {\n    font-size: 0.85rem;\n    background-color: var(--color-bg-subtab);\n}\n\n\n.stickyHeader {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    /* Ensure items are spaced out */\n    background-color: var(--color-bg-header);\n    /* Optional: Set a background color */\n    \n    /* Adjust padding as needed */\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    /* Optional: Add a shadow */\n    position: sticky;\n    top: 0;\n    z-index: 1000;\n}\n\n.logoContainer {\n    display: flex;\n    align-items: center;\n}\n\n.logo {\n    height: 80px;\n    /* Adjust logo size as needed */\n    width: auto;\n    padding-left: 5px;\n    \n}\n\n.loadingContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: var(--color-bg);\n  color: var(--color-text);\n}\n\n.loadingContainer p {\n  margin-top: 1rem;\n  font-size: 1.2rem;\n}\n\n.userSection {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.headerTitleWrap {\n  display: flex;\n  align-items: center;\n  margin-left: 16px;\n  white-space: nowrap;\n}\n\n@media (min-width: 1025px) {\n  .headerMobileControls {\n    align-items: center;\n    justify-content: flex-end;\n    flex-wrap: nowrap;\n  }\n}\n\n\n.userMenu {\n  position: relative;\n}\n\n.userMenuButton {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-panel);\n  color: var(--color-text);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.userMenuIcon {\n  font-size: 18px;\n  color: var(--color-text);\n}\n\n.userAvatar {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.userAvatarFallback {\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.userMenuDropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 220px;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);\n  padding: 10px;\n  z-index: 1000;\n}\n\n.userMenuMeta {\n  padding: 4px 8px 8px;\n  border-bottom: 1px solid var(--color-border);\n  margin-bottom: 8px;\n}\n\n.userMenuName {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--color-text);\n}\n\n.userMenuEmail {\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n.userMenuItem {\n  width: 100%;\n  text-align: left;\n  border: none;\n  background: transparent;\n  color: var(--color-text);\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.85rem;\n}\n\n.userMenuItem:hover {\n  background: var(--color-bg-muted);\n}\n\n.userMenuSection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 6px 8px;\n}\n\n.userMenuLabel {\n  font-size: 0.75rem;\n  color: var(--color-text-muted);\n}\n\n.userMenuSelect {\n  background: var(--color-bg-alt);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 6px;\n  padding: 4px 6px;\n  font-size: 0.75rem;\n}\n\n.userInfo {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  color: var(--color-text);\n  font-size: 0.9rem;\n}\n\n.signOutButton {\n  background: var(--color-bg-tab);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.8rem;\n}\n\n.signOutButton:hover {\n  background: var(--color-bg-tab-active);\n  border-color: var(--color-border);\n}\n\n@media (max-width: 768px) {\n  .userSection {\n    display: none;\n  }\n  \n  .userInfo {\n    font-size: var(--font-size-label);\n  }\n  \n  .signOutButton {\n    padding: 0.4rem 0.8rem;\n    font-size: var(--font-size-tiny);\n  }\n}\n\n.themeToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--color-text);\n  font-size: var(--font-size-label);\n}\n\n.themeLabel {\n  color: var(--color-text-muted);\n  font-size: var(--font-size-caption);\n}\n\n.themeSelect {\n  background: var(--color-bg-alt);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 6px;\n  padding: 2px 6px;\n  font-size: var(--font-size-label);\n}\n\n.settingsPage {\n  display: flex;\n  gap: 24px;\n  padding: 24px 16px;\n}\n\n.settingsSidebar {\n  width: 220px;\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 16px;\n  height: fit-content;\n}\n\n.settingsTitle {\n  margin: 0 0 12px;\n  font-size: var(--font-size-section);\n  color: var(--color-text-strong);\n}\n\n.settingsNav {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.settingsNavItem {\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  text-align: left;\n  padding: 8px 10px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: var(--font-size-body);\n}\n\n.settingsNavItem:hover {\n  background: var(--color-bg-muted);\n  color: var(--color-text);\n}\n\n.settingsNavItemActive {\n  background: rgba(141, 160, 216, 0.15);\n  color: var(--color-accent);\n}\n\n.settingsContent {\n  flex: 1;\n  min-width: 0;\n}\n\n.settingsPanel {\n  background: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.settingsPanelTitle {\n  margin: 0 0 6px;\n  font-size: var(--font-size-section);\n  color: var(--color-text-strong);\n}\n\n.settingsPanelDescription {\n  margin: 0 0 16px;\n  font-size: var(--font-size-body);\n  color: var(--color-text-muted);\n}\n\n.settingRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 0;\n  border-top: 1px solid var(--color-border);\n}\n\n.settingLabel {\n  font-size: var(--font-size-body);\n  color: var(--color-text);\n}\n\n.settingHint {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.settingSelect {\n  min-width: 140px;\n  background: var(--color-bg-alt);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: var(--font-size-body);\n}\n\n.uploadPanel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  background: var(--color-bg-muted);\n  border: 1px solid var(--color-border);\n  border-radius: 10px;\n  padding: 16px;\n}\n\n.uploadRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.uploadFileInput {\n  background: var(--color-bg-alt);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: var(--font-size-body);\n}\n\n.uploadStatus {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n}\n\n.uploadButton {\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 8px 14px;\n  background: var(--color-bg-card);\n  color: var(--color-text);\n  cursor: pointer;\n  font-size: var(--font-size-body);\n}\n\n.uploadButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.uploadMeta {\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.uploadDivider {\n  height: 1px;\n  width: 100%;\n  background: var(--color-border);\n  opacity: 0.6;\n}\n\n.typeScaleSectionHeader {\n  margin-top: 16px;\n  margin-bottom: 6px;\n  font-size: var(--font-size-label);\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.typeScalePresetGrid {\n  display: grid;\n  gap: 8px;\n}\n\n.typeScalePresetHeader {\n  display: grid;\n  grid-template-columns: 120px repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  font-size: var(--font-size-caption);\n  color: var(--color-text-muted);\n  padding: 6px 0;\n}\n\n.typeScalePresetRow {\n  display: grid;\n  grid-template-columns: 120px repeat(3, minmax(0, 1fr));\n  gap: 8px;\n  align-items: center;\n}\n\n.typeScalePresetLabel {\n  font-size: var(--font-size-body);\n  color: var(--color-text);\n}\n\n.typeScalePresetInput {\n  background: var(--color-bg-alt);\n  border: 1px solid var(--color-border);\n  color: var(--color-text);\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: var(--font-size-body);\n  width: 100%;\n}\n\n.typeScalePresetActions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.typeScaleResetButton {\n  border: 1px solid var(--color-border);\n  background: var(--color-bg-muted);\n  color: var(--color-text);\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: var(--font-size-body);\n  cursor: pointer;\n}\n\n.typeScaleResetButton:hover {\n  background: var(--color-bg-panel);\n}\n\n@media (max-width: 900px) {\n  .settingsPage {\n    flex-direction: column;\n  }\n  .settingsSidebar {\n    width: 100%;\n  }\n}\n\n@media (max-width: 720px) {\n  .typeScalePresetHeader {\n    display: none;\n  }\n  .typeScalePresetRow {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Integrated Header Navigation */\n.headerNav {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin-right: 16px;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n}\n\n.headerNavLink {\n  padding: 8px 14px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: var(--font-size-body);\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.headerNavLink:hover {\n  color: var(--color-text);\n  background-color: var(--color-bg-muted);\n}\n\n.headerNavLinkActive {\n  color: var(--color-accent);\n  background-color: rgba(141, 160, 216, 0.15);\n}\n\n.headerNavMobile {\n  display: none;\n  align-items: center;\n  gap: 6px;\n  margin: 0 12px;\n}\n\n.headerMobileControls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  flex-wrap: nowrap;\n}\n\n.headerNavMobileButton {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  padding: 6px 8px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 52px;\n}\n\n.headerNavMobileButton:hover {\n  color: var(--color-text);\n  background-color: var(--color-bg-muted);\n}\n\n.headerNavMobileButtonActive {\n  color: var(--color-accent);\n  background-color: rgba(141, 160, 216, 0.15);\n}\n\n.headerNavMobileIcon {\n  font-size: 18px;\n}\n\n.headerNavMobileLabel {\n  font-size: 0.65rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n@media (max-width: 1024px) {\n  .headerNav {\n    display: none;\n  }\n  .headerNavMobile {\n    display: flex;\n  }\n  .headerMobileControls {\n    order: 2;\n    width: auto;\n    justify-content: flex-end;\n    gap: 6px;\n    margin-left: auto;\n  }\n  .stickyHeader {\n    flex-wrap: wrap;\n    align-items: flex-start;\n    gap: 4px;\n    padding-top: 5px;\n  }\n  .headerTitleWrap {\n    display: flex;\n    order: 3;\n    width: 100%;\n    justify-content: flex-end;\n    padding-right: 5px;\n    margin-top: 4px;\n    margin-left: 0;\n    white-space: normal;\n  }\n  .logoContainer {\n    order: 1;\n  }\n}\n\n\n\n\n@media (max-width: 1024px) {\n  .headerNavMobile {\n    margin: 0;\n    gap: 4px;\n    align-items: flex-start;\n  }\n\n  .logo {\n    height: 40px;\n  }\n}\n@media (max-width: 1024px) {\n  .userSection {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n  }\n}\n\n\n/* Header Navigation Dropdown */\n.headerNavDropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.headerNavDropdown:hover .headerNavDropdownMenu {\n  opacity: 1;\n  visibility: visible;\n  transform: translateY(0);\n}\n\n.headerNavDropdownMenu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  min-width: 140px;\n  background-color: var(--color-bg-panel);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  padding: 8px 0;\n  opacity: 0;\n  visibility: hidden;\n  transform: translateY(-8px);\n  transition: all 0.2s ease;\n  z-index: 1000;\n}\n\n.headerNavDropdownItem {\n  display: block;\n  width: 100%;\n  padding: 10px 16px;\n  border: none;\n  background: transparent;\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: left;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.headerNavDropdownItem:hover {\n  color: var(--color-text);\n  background-color: var(--color-bg-muted);\n}\n\n.headerNavDropdownItemActive {\n  color: var(--color-accent);\n  background-color: rgba(141, 160, 216, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `App_tooltip__LQX4F`,
	"app": `App_app__zr1wm`,
	"sideHeader": `App_sideHeader__PyG1O`,
	"sideNavContent": `App_sideNavContent__9Yf1m`,
	"sideHeaderOpen": `App_sideHeaderOpen__F7neK`,
	"hamburger": `App_hamburger__N9fDT`,
	"mainContent": `App_mainContent__mD5IX`,
	"container": `App_container__Rt8T2`,
	"appFooter": `App_appFooter__eNXpo`,
	"appFooterInner": `App_appFooterInner__IoZ7Z`,
	"appFooterBrand": `App_appFooterBrand__tUF5E`,
	"appFooterTitle": `App_appFooterTitle__6KUv4`,
	"appFooterMeta": `App_appFooterMeta__umVa9`,
	"appFooterLinks": `App_appFooterLinks__AAyKQ`,
	"appFooterLink": `App_appFooterLink__KLybn`,
	"appFooterDisclaimer": `App_appFooterDisclaimer__NdIWJ`,
	"containerWithSidebar": `App_containerWithSidebar__vQZSt`,
	"header": `App_header__fhC8n`,
	"content": `App_content__wwONY`,
	"tabs": `App_tabs__IkL1T`,
	"tab": `App_tab__7vr6n`,
	"activeTab": `App_activeTab__DXddT`,
	"subTabs": `App_subTabs__69JLr`,
	"subTab": `App_subTab__aXxg+`,
	"stickyHeader": `App_stickyHeader__cmCRN`,
	"logoContainer": `App_logoContainer__CWdD-`,
	"logo": `App_logo__7Edbg`,
	"loadingContainer": `App_loadingContainer__HttAr`,
	"userSection": `App_userSection__txw-4`,
	"headerTitleWrap": `App_headerTitleWrap__XnFzt`,
	"headerMobileControls": `App_headerMobileControls__k3s9o`,
	"userMenu": `App_userMenu__OqGSf`,
	"userMenuButton": `App_userMenuButton__yThPq`,
	"userMenuIcon": `App_userMenuIcon__JieMw`,
	"userAvatar": `App_userAvatar__DvYkj`,
	"userAvatarFallback": `App_userAvatarFallback__nQGp8`,
	"userMenuDropdown": `App_userMenuDropdown__vKb+k`,
	"userMenuMeta": `App_userMenuMeta__JGQuB`,
	"userMenuName": `App_userMenuName__MEiMV`,
	"userMenuEmail": `App_userMenuEmail__MfYq7`,
	"userMenuItem": `App_userMenuItem__NJVkH`,
	"userMenuSection": `App_userMenuSection__-9L+y`,
	"userMenuLabel": `App_userMenuLabel__AzM7j`,
	"userMenuSelect": `App_userMenuSelect__NHYOx`,
	"userInfo": `App_userInfo__UEmqj`,
	"signOutButton": `App_signOutButton__k8vNI`,
	"themeToggle": `App_themeToggle__ijVfI`,
	"themeLabel": `App_themeLabel__gopg2`,
	"themeSelect": `App_themeSelect__gwy9a`,
	"settingsPage": `App_settingsPage__dVWtF`,
	"settingsSidebar": `App_settingsSidebar__2oz0h`,
	"settingsTitle": `App_settingsTitle__GtEi1`,
	"settingsNav": `App_settingsNav__Rj9rf`,
	"settingsNavItem": `App_settingsNavItem__VP6Mb`,
	"settingsNavItemActive": `App_settingsNavItemActive__L+ns4`,
	"settingsContent": `App_settingsContent__LSatc`,
	"settingsPanel": `App_settingsPanel__Grd0E`,
	"settingsPanelTitle": `App_settingsPanelTitle__BWORO`,
	"settingsPanelDescription": `App_settingsPanelDescription__9jQsn`,
	"settingRow": `App_settingRow__Ac11r`,
	"settingLabel": `App_settingLabel__8-9cR`,
	"settingHint": `App_settingHint__lex7i`,
	"settingSelect": `App_settingSelect__+MzB5`,
	"uploadPanel": `App_uploadPanel__IprpB`,
	"uploadRow": `App_uploadRow__MkEEd`,
	"uploadFileInput": `App_uploadFileInput__RIG0A`,
	"uploadStatus": `App_uploadStatus__W5Dw+`,
	"uploadButton": `App_uploadButton__gqWai`,
	"uploadMeta": `App_uploadMeta__sh8kG`,
	"uploadDivider": `App_uploadDivider__NyWJk`,
	"typeScaleSectionHeader": `App_typeScaleSectionHeader__GLQ5o`,
	"typeScalePresetGrid": `App_typeScalePresetGrid__kYZX9`,
	"typeScalePresetHeader": `App_typeScalePresetHeader__vdRh8`,
	"typeScalePresetRow": `App_typeScalePresetRow__HecGW`,
	"typeScalePresetLabel": `App_typeScalePresetLabel__05eYK`,
	"typeScalePresetInput": `App_typeScalePresetInput__cDfYO`,
	"typeScalePresetActions": `App_typeScalePresetActions__xp7MR`,
	"typeScaleResetButton": `App_typeScaleResetButton__PlNdg`,
	"headerNav": `App_headerNav__CGsod`,
	"headerNavLink": `App_headerNavLink__AutGZ`,
	"headerNavLinkActive": `App_headerNavLinkActive__-8dop`,
	"headerNavMobile": `App_headerNavMobile__gVRoC`,
	"headerNavMobileButton": `App_headerNavMobileButton__SwwVf`,
	"headerNavMobileButtonActive": `App_headerNavMobileButtonActive__bAJ25`,
	"headerNavMobileIcon": `App_headerNavMobileIcon__wkHZy`,
	"headerNavMobileLabel": `App_headerNavMobileLabel__gRnrb`,
	"headerNavDropdown": `App_headerNavDropdown__qS+Ij`,
	"headerNavDropdownMenu": `App_headerNavDropdownMenu__VLbQZ`,
	"headerNavDropdownItem": `App_headerNavDropdownItem__kMF0G`,
	"headerNavDropdownItemActive": `App_headerNavDropdownItemActive__xJtVT`
};
export default ___CSS_LOADER_EXPORT___;
